<flx-modal
  [dismissible]="true"
  (dismiss)="closeModal()"
  class="flx-ds"
>
  <div
    class="flx-modal-title"
    flxModalHeaderTitle
  >
    {{ title() }}
  </div>
  <div
    class="flx-modal-subtitle"
    flxModalHeaderSubtitle
  >
    {{ subtitle() }}
  </div>

  <div class="flx-modal-body">
    @if (showResourceSelector()) {
      <flx-select
        [formControl]="resourceFC"
        [hasSearch]="true"
        [hasClear]="false"
        (filterChange)="resourceFilter.set($event)"
        class="w-full flx-ds"
        emptyMessage="Nothing found"
        placeholder="Choose a version"
        data-testId="entry-point-selector"
      >
        <flx-label class="flx-ds">{{ selectorLabel() }}</flx-label>
        @for (resource of this.filteredResources(); track resource) {
          <flx-select-option
            [value]="resource.resourceId"
            [attr.data-testid]="'process-option-' + resource.resourceName"
          >
            {{ resource.resourceName }}
          </flx-select-option>
        }
      </flx-select>
    }
    @if ((hasEmailTriggerNode || hasWebhookTriggerNode) && hasStartNode) {
      <flx-select
        [formControl]="startNodeFC"
        [hasClear]="false"
        class="w-full flx-ds"
      >
        <flx-label class="flx-ds">Start type</flx-label>
        <flx-select-option [value]="startType.START_FROM_EVENT">Manual Start</flx-select-option>
        <flx-select-option [value]="startType.START_FROM_EMAIL">Start from email</flx-select-option>
      </flx-select>
    }
    @if (hasEmailTriggerNode && startNodeFC.value === startType.START_FROM_EMAIL) {
      <div
        [formGroup]="emailFormGroup"
        class="flex flex-col gap-2"
      >
        <flx-input class="flx-ds w-full">
          <flx-label class="flx-ds">Subject</flx-label>
          <input
            formControlName="subject"
            flxInput
            placeholder="Enter Email Subject"
          />
        </flx-input>

        <div class="flex gap-4">
          <flx-input class="flx-ds flex-1">
            <flx-label class="flx-ds">Sender</flx-label>
            <input
              formControlName="sender"
              flxInput
              placeholder="Enter Email Sender"
            />
          </flx-input>

          <div class="flex-1 flex flex-col">
            <flx-label class="flx-ds">Datetime</flx-label>
            <p-datepicker
              [iconDisplay]="'input'"
              [showTime]="true"
              [showIcon]="true"
              class="flx-ds date-picker"
              formControlName="dateTime"
              placeholder="Set Date & Hour"
              appendTo="body"
            ></p-datepicker>
          </div>
        </div>

        <flx-textarea class="flx-ds w-full">
          <flx-label class="flx-ds">Body</flx-label>
          <textarea
            formControlName="body"
            flxTextarea
            placeholder="Email Body"
            rows="5"
          ></textarea>
        </flx-textarea>

        <div>
          <div class="flex justify-between items-center">
            <span class="font-lg font-semibold">Upload files</span>
            <flx-file-upload
              [accept]="'.pdf,.doc,.docx,.txt,.png,.jpg,.jpeg,.xls,.xlsx,.csv,.zip'"
              [maxFileSize]="26214400"
              (upload)="onFileUpload($event)"
            >
              <button
                class="flx-ds ternary hover:bg-transparent hover:border-white"
                flxButton
              >
                Click to upload
              </button>
            </flx-file-upload>
          </div>

          <flx-helper class="flex w-full bg-neutral-50 rounded p-2 gap-2 items-center">
            <i class="ph ph-lightbulb text-yellow-500 text-base"></i>
            <span class="text-xs text-neutral-500">
              Accepted files: PDF, DOCUMENT (.doc, .docx, .txt), IMAGE (.png, .jpg, .jpeg), EXCEL
              (.xls, .xlsx, .csv), ZIP (.zip) up to 25MB
            </span>
          </flx-helper>
        </div>

        @if (uploadedFiles.length > 0) {
          <div class="flex flex-col gap-1">
            @for (file of uploadedFiles; track file.id) {
              <div class="flex items-center justify-between p-1 rounded-lg hover:bg-neutral-50">
                <div class="flex items-center">
                  <i class="ph ph-file text-neutral-500 mr-2"></i>
                  <span class="text-sm">{{ file.filename }}</span>
                </div>
                <button
                  (click)="removeFile($index)"
                  class="flx-ds ternary small"
                  flxButton
                  icon="center"
                >
                  <i
                    class="ph ph-trash-simple text-neutral-900"
                    flxIcon
                  ></i>
                </button>
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <div
        [formGroup]="startDataForm"
        class="h-full flex flex-col"
      >
        <flx-code-editor
          [options]="editorOptions"
          class="h-[476px]"
          formControlName="startData"
        />
        <flx-helper>JSON data</flx-helper>
      </div>
    }
    <flx-select
      [formControl]="themeFC"
      [hasClear]="false"
      class="w-full flx-ds"
      data-testId="theme-selector"
    >
      <flx-label class="flx-ds">Theme</flx-label>
      <flx-icon
        name="theme-icon"
        flxPrefixIcon
      ></flx-icon>
      @for (theme of this.themes; track theme) {
        <flx-select-option
          [value]="theme.flowxUuid"
          [attr.data-testId]="theme.name"
        >
          {{ theme.name }}
        </flx-select-option>
      }
    </flx-select>
  </div>

  <div class="flx-modal-footer">
    <div class="flx-modal-footer__right">
      <button
        [disabled]="hasEmailTriggerNode || hasWebhookTriggerNode ? false : startDataForm.invalid"
        (click)="start()"
        class="flx-ds primary"
        data-testId="confirm-start-process-button"
        flxButton
      >
        {{ ctaLabel() }}
      </button>
    </div>
  </div>
</flx-modal>
